import axios from "axios";
import SaveCustomerCheckoutUrl from "./SaveCustomerCheckoutUrl";
import ShopifyCreateMultipassToken from "./ShopifyCreateMultipassToken";
import ShopifyGetCustomer from "./ShopifyGetCustomer";
import ShopifyUpdateCartBuyerIdentity from "./ShopifyUpdateCartBuyerIdentity";
import SaveCustomerCartIdToMetafield from "./SaveCustomerCartIdToMetafield";
import API_VERSION from "../data/api-version";

const ShopifyCreateCheckout = async (token, lineItems, orderAttributes, isKiosk = false) => {
  const mappedLines = lineItems.map((item) => {
    const attributesArray = Array.isArray(item.customAttributes)
      ? item.customAttributes
      : item.customAttributes
      ? [item.customAttributes]
      : [];

    return {
      quantity: item.quantity,
      merchandiseId: item.variantId,
      attributes: attributesArray,
    };
  });

  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_AFFILIATE_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `
          mutation CartCreate($input: CartInput!) {
            cartCreate(input: $input) {
              cart {
                id
                checkoutUrl
              }
              userErrors {
                field
                message
              }
            }
          }
        `,
        variables: {
          input: {
            lines: mappedLines,
            attributes: orderAttributes,
            buyerIdentity: {
              countryCode: "US",
            },
          },
        },
      },
    });
    const cartCreate = response?.data?.data?.cartCreate;

    if (!cartCreate || cartCreate.userErrors.length > 0) {
      console.error("Cart creation error:", cartCreate.userErrors);
      return null;
    }

    const { cart } = cartCreate;
    const checkoutUrl = cart.checkoutUrl;
    const cartId = cart.id;

    if (!token) {
      return { checkoutUrl };
    }

    const customer = await ShopifyGetCustomer(token);
    const multipassToken = await ShopifyCreateMultipassToken(customer.email);
    const customerId = customer.id;

    const finalCheckoutUrl = isKiosk
      ? `${checkoutUrl}&_customerId=${btoa(customerId.replace("gid://shopify/Customer/", ""))}`
      : checkoutUrl;

    await Promise.all([
      SaveCustomerCheckoutUrl(customerId, finalCheckoutUrl),
      SaveCustomerCartIdToMetafield(cartId, customerId),
      ShopifyUpdateCartBuyerIdentity(cartId, customer),
    ]);

    return {
      checkoutUrl: finalCheckoutUrl,
      multipassToken,
    };
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyCreateCheckout;
